module.exports = __webpack_public_path__ + "static/media/html.e3cc2ea2.png";